var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.user.user_type === _vm.CORPCLIENT)?[_c('ClientCalcCompliance',{attrs:{"userId":_vm.user.id,"userType":"CorpClient"}})]:[_vm._v(" Эта страница есть только у корпоративных клиентов ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }